import ApplicationSTD from "./components/ApplicationSTD";
import ApplicationCDLI from "./components/ApplicationCDLI";
import ApplicationDBTIMakati from "./components/ApplicationDBTIMakati";

export function Application() {

   var subdomain = localStorage.getItem("lms-subdomain");

   const application = () => {
      const components = {
         'dbti-makati': ApplicationDBTIMakati,
         'localhost': ApplicationSTD,
         'casadellibroinc': ApplicationCDLI
      };

      const Component = components[subdomain] || ApplicationSTD;
      return <Component />;
   };

   return (
      <>
         {
            application()
         }
      </>
   )
}
